<template>
  <div :style="{ display: 'flex', justifyContent: align }">
    <span
        v-for="(item, index) in parsedSegments"
        :key="index"
        :style="{ color: item.color, fontSize: `${baseFontSize}px`, whiteSpace: 'nowrap' }"
    >
      {{ item.text }}
    </span>
  </div>
</template>

<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    targetString: { type: String, required: true },
    defaultColor: { type: String, default: '#333333' },
    addFontSize: { type: Number, default: 0 },
    align: { type: String, default: 'flex-start' } // 可传 'center', 'flex-end', 'space-between' 等
  })

  // 假设基础字号是 14px
  const baseFontSize = 14 + props.addFontSize

  const parsedSegments = computed(() => {
    const result = []
    const reg = /\[S-(\w{6})\](.*?)\[E\]/g
    let lastIndex = 0
    let match

    while ((match = reg.exec(props.targetString)) !== null) {
      const matchStart = match.index
      const matchEnd = reg.lastIndex

      // 前面的普通文本
      if (lastIndex < matchStart) {
        result.push({
          text: props.targetString.slice(lastIndex, matchStart),
          color: props.defaultColor
        })
      }

      // 带颜色的文本
      result.push({
        text: match[2],
        color: `#${match[1]}`
      })

      lastIndex = matchEnd
    }

    // 剩余普通文本
    if (lastIndex < props.targetString.length) {
      result.push({
        text: props.targetString.slice(lastIndex),
        color: props.defaultColor
      })
    }

    return result
  })
</script>

<style scoped>
</style>
